import { Button, ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import React from "react";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";
import { useNavigate } from "react-router-dom";
import globalStyles from "../../style/global.js";
import { useTranslation } from "react-i18next";
import moment from "moment";

function RecentNotifications(props) {
  const globalClasses = globalStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <div>
        {props.data.map((element) => {
          return (
            <MenuItem>
              <ListItemIcon>
                <CircleNotificationsIcon
                 
                  color="secondary"
                ></CircleNotificationsIcon>
              </ListItemIcon>
              <ListItemText primary={element.text} secondary={ 
                
                moment(element.date, "DDMMYYYYHH").fromNow()}  />
            </MenuItem>
          );
        })}
        <Button
          sx={{
            display: "flex",
            justifyContent: "center",
          
          }}
          fullWidth
          color="secondary"
          variant="outlined"
          onClick={() => {
              navigate("/notifications")
          }}
        >
          {t("viewAll")}
        </Button>
      </div>
    </>
  );
}

export default RecentNotifications;
